import ChallengesBlock from './ChallengesBlock';

export default ChallengesBlock;
